export const SW_VERSION = "34800358bea37b9ff2fe82071a199c72";